var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / star unfilled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M12.1016 16.2802L12.1016 16.2802L8.48976 17.749L8.77047 13.86C8.79863 13.47 8.67332 13.0843 8.42127 12.7853L5.90831 9.80409L9.69364 8.86932C10.0733 8.77556 10.4014 8.53722 10.6079 8.20509L12.6666 4.89389L14.7254 8.20509L15.5746 7.67708L14.7254 8.20509C14.9319 8.53722 15.2599 8.77556 15.6396 8.86932L19.4249 9.80409L16.912 12.7853C16.6599 13.0843 16.5346 13.47 16.5628 13.86L16.8435 17.749L13.2317 16.2802L12.855 17.2066L13.2317 16.2802C12.8694 16.1329 12.4639 16.1329 12.1016 16.2802ZM5.12759 9.99689L5.1282 9.99674C5.128 9.99679 5.12779 9.99684 5.12759 9.99689L5.00772 9.51147L5.12759 9.99689Z",
    stroke: "url(#paint0_linear_2563_1855)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2563_1855",
    x1: 12.6666,
    y1: 3,
    x2: 12.6666,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A26D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilled);
export default __webpack_public_path__ + "static/media/unfilled.e6e67f8da378cfc294487b3710d98d09.svg";
export { ForwardRef as ReactComponent };